/*
 * LARENA motion — restrained on purpose.
 * Sections fade up once as they enter the viewport; nothing loops, nothing
 * moves again after it has arrived. Everything is skipped under
 * prefers-reduced-motion, and content is visible without JavaScript
 * (the hidden state is only applied once this script has run).
 */
// Only the hero film that is actually shown should play; stop the other one
// downloading (phone shows the portrait cut, desktop the landscape one).
(() => {
  const sync = () => document.querySelectorAll('.slide__video').forEach((v) => {
    const hidden = getComputedStyle(v).display === 'none';
    if (hidden) { v.pause(); v.removeAttribute('autoplay'); v.preload = 'none'; }
    else if (v.paused) v.play().catch(() => {});
  });
  sync();
  window.matchMedia('(max-width: 749px)').addEventListener('change', sync);
})();

(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const targets = [
    ...document.querySelectorAll('[data-reveal]'),
    ...document.querySelectorAll('main .shopify-section:not(:first-child) > *:first-child'),
  ];
  const seen = new Set();
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('lx-in');
        io.unobserve(e.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  targets.forEach((el) => {
    if (seen.has(el)) return;
    seen.add(el);
    const r = el.getBoundingClientRect();
    if (r.top < window.innerHeight) return; // already on screen: leave it be
    el.classList.add('lx-reveal');
    io.observe(el);
  });
})();
